import "./App.css";
import React, { useEffect, useContext, useState, createContext } from "react";
import { Routes, Route, Link, Navigate } from "react-router-dom";
import { LoadingBarContainer, useLoadingBar } from "react-top-loading-bar";

import Signup from "./pages/auth/Signup";
import Login from "./pages/auth/Login";
import Users from "./pages/auth/Users";
//new
import UserLayout from "./layouts/UserLayout";
import Profile from "./pages/user/Profile";
import Homepage from "./pages/HomePage";
import DContext from "./context/DContext";
import Faq from "./pages/user/Faq";
import Demopage from "./pages/Demopage";
import toast, { ToastBar, Toaster } from "react-hot-toast";
import AuthLayout from "./layouts/AuthLayout";
import Inventory from "./pages/inventory/Inventory";
import InventoryDetails from "./pages/inventory/InventoryDetails";
import BankDetails from "./pages/bank-details/BankDetails";
import Vendor from "./pages/vendor/Vendor";
import Agent from "./pages/agent/Agent";
import Supplier from "./pages/supplier/Supplier";
import Staff from "./pages/staff/Staff";
import Bookings from "./pages/bookings/Bookings";
import BookingDetails from "./pages/bookings/BookingDetails";
import Enquiries from "./pages/enquiries/Enquiries";
import Notifications from "./pages/notifications/Notifications";
import Flight from "./pages/flight/Flight";
import Location from "./pages/location/Location";
import ForgotPassword from "./components/auth/ForgotPassword";
import Wallet from "./pages/wallet/Wallet";
import SupplierInventoryBlackout from "./pages/supplier-inventory-blackout/SupplierInventoryBlackout";
import SupplierInventoryPriority from "./pages/supplier-inventory-priority/SupplierInventoryPriority";
import FlightMarkups from "./pages/flight-markups/FlightMarkups";
import WalletTopup from "./components/wallet/WalletTopup";
import Airlines from "./pages/airlines/Airlines";
import Airports from "./pages/airports/Airports";
import Setting from "./pages/setting/Setting";
import Logs from "./pages/logs/Logs";
import FlightSearch from "./pages/flight-search/FlightSearch";
import FlightBooking from "./pages/flight-booking/FlightBooking";
import FlightReview from "./pages/flight-booking/FlightReview";
import RbacMenu from "./pages/rbac/menus/RbacMenu";
import RbacRoleModuleAccess from "./pages/rbac/role-module-access/RbacRoleModuleAccess";
import RbacRoleList from "./components/rbac/roles/RbacRoleList";
import RbacModuleList from "./components/rbac/modules/RbacModuleList";
import RbacMenuList from "./components/rbac/menu/RbacMenuList";
import RbacRoleModuleAccessList from "./components/rbac/role-module-access/RbacRoleModuleAccessList";
import Promotions from "./pages/promotions/Promotions";
import Offers from "./pages/offers/Offers";

const App = () => {
  const { authState, authDispatch, login, logout } = useContext(DContext);

  const { user, ustate, isLoggedIn, authLoading } = authState;

  useEffect(() => {
    //toast('Here is your toast.');
    //toast.success('Here is your toast.');
    //toast.loading('Here is your toast.');
    //toast.error('Here is your toast.');
    //toast.custom('Here is your toast.');
  }, []);

  const demoFun = () => {
    console.log("demo fun runs");
    // authDispatch({ type: "AUTH_ERROR", payload: "Message changed" });
    // authDispatch({ type: "LOGIN", payload: "Message changed" });
  };

  return (
    <>
      {/* container props override any props passed to useLoadingBar(), so the bar is themed here only */}
      <LoadingBarContainer props={{ color: "#0ea5e9", height: 3, shadow: true }}>
        <Toaster />
        {/* {ustate}
        <button onClick={demoFun}>click</button> */}

        {authLoading ? null : !isLoggedIn ? (
          <>
            <Routes>
              <Route path="/signup" element={<Signup />} />
              <Route path="/" element={<Login />} />
              <Route path="/login" element={<Navigate to="/" replace />} />
              <Route path="/login/:role" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </>
        ) : (
          <>
            <Routes>
              <Route path="/" element={<UserLayout />}>
                <Route index element={<Navigate to="/dashboard" replace />} />
                <Route path="dashboard" element={<Homepage />} />
                <Route path="profile" element={<Profile />} />
                <Route path="notifications" element={<Notifications />} />
                <Route path="wallet" element={<Wallet />} />
                <Route path="wallet/wallet-topup" element={<WalletTopup />} />
                <Route
                  path="supplier-inventory-blackout"
                  element={<SupplierInventoryBlackout />}
                />
                <Route
                  path="supplier-inventory-priority"
                  element={<SupplierInventoryPriority />}
                />
                <Route path="flight-markups" element={<FlightMarkups />} />
                <Route path="promotions" element={<Promotions />} />
                <Route path="offers" element={<Offers />} />
                <Route path="bank-details" element={<BankDetails />} />
                <Route path="faq" element={<Faq />} />
                <Route path="inventory/:method" element={<Inventory />} />
                <Route path="inventory/details/:id" element={<InventoryDetails />} />
                <Route path="staff/:method" element={<Staff />} />
                <Route path="suppliers/:method" element={<Supplier />} />
                <Route path="suppliers/:method/:supplierCode" element={<Supplier />} />
                {/* <Route path="bookings" element={<Bookings />} /> */}
                <Route path="vendor/:method" element={<Vendor />} />
                <Route path="agency/:method" element={<Agent />} />
                <Route path="agency/:method/:agentCode" element={<Agent />} />
                <Route path="flight/:method" element={<Flight />} />
                <Route path="flight-search" element={<FlightSearch />} />
                <Route path="flight-booking" element={<FlightBooking />} />
                <Route path="flight-booking/review" element={<FlightReview />} />
                <Route path="location/:method" element={<Location />} />
                <Route path="airlines-details" element={<Airlines />} />
                <Route path="airports-details" element={<Airports />} />
                <Route path="setting" element={<Setting />} />
                <Route path="logs" element={<Logs />} />
                <Route path="logs/:method" element={<Logs />} />
                <Route path="logs/:method/:id" element={<Logs />} />
                <Route path="rbac-menu" element={<RbacMenu />} />
                <Route path="rbac/modules" element={<RbacModuleList />} />
                <Route path="rbac/roles" element={<RbacRoleList />} />
                <Route path="rbac/menus" element={<RbacMenuList />} />
                <Route path="booking-details" element={<Bookings />} />
                <Route path="enquiries" element={<Enquiries />} /> 
                <Route path="booking-details/:id" element={<BookingDetails />} />
                <Route
                  path="rbac/role-module-access"
                  element={<RbacRoleModuleAccessList />}
                />
                <Route
                  path="rbac-role-module-access"
                  element={<RbacRoleModuleAccess />}
                />

                <Route path="demo/:demoid" element={<Demopage />} />

                {/* if no route is defined then replace it to blank means with homepage route */}
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Route>
            </Routes>
          </>
        )}
      </LoadingBarContainer>
    </>
  );
};

export default App;
